import React from 'react';
import BillingConstants from 'app/shared/constants/BillingConstants';
import { useSelector } from 'react-redux';

import {
    Button,
    IconPlus,
    Spacer,
} from '@zillow/constellation';

import { BillingAddPaymentModalContainer } from './StyledComponents';

import MetroidIframeWrapper from './MetroidIframeWrapper';

const { PAYMENT_TYPES } = BillingConstants;

const BillingAddPaymentModal = ({ onCreditCardAdded, accountNumber }) => {
    const cookieEnabledServices = useSelector(state => state.app.cookieEnabledServices);
    const userCanAccessAch = useSelector(state => state.billing.accountPaymentMethods.canAccessAch);
    const canAccessAch = Boolean(cookieEnabledServices.ZG_ACH_PAYMENTS_ENABLED) || userCanAccessAch;

    const [selectedType, setSelectedType] = React.useState(canAccessAch ? null : PAYMENT_TYPES.CREDIT_CARD);

    const renderTypeSelection = () => (
        <>
            <Spacer marginY="sm">
                <Button
                    buttonType="secondary"
                    fluid={true}
                    icon={<IconPlus />}
                    onClick={() => setSelectedType(PAYMENT_TYPES.CREDIT_CARD)}
                >
                    Credit card payment
                </Button>
            </Spacer>
            {canAccessAch && (
                <Spacer marginY="sm">
                    <Button
                        buttonType="secondary"
                        fluid={true}
                        icon={<IconPlus />}
                        onClick={() => setSelectedType(PAYMENT_TYPES.ACH)}
                    >
                        ACH Payment
                    </Button>
                </Spacer>
            )}
        </>
    );

    const renderIframe = () => (
        <MetroidIframeWrapper
            onCreditCardAdded={onCreditCardAdded}
            accountNumber={accountNumber}
            selectedType={selectedType}
        />
    );

    return (
        <BillingAddPaymentModalContainer>
            {selectedType ? renderIframe() : renderTypeSelection()}
        </BillingAddPaymentModalContainer>
    );
};

export default BillingAddPaymentModal;
